"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfirmDialog = ConfirmDialog;
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ConfirmDialog(_ref) {
  var name = _ref.name;
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    sx: {
      flexGrow: 1,
      textAlign: "center"
    }
  }, /*#__PURE__*/_react.default.createElement("p", null, "Thanks ", name, ". Your message has been sent. Have a great day!"));
}